import { Component, EventEmitter, OnInit, Output, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatCardModule } from '@angular/material/card';
import { NewRepApplicationPage } from '../new-rep-application/new-rep-application/new-rep-application.page';
import { NewRepChecklistComponent } from '../new-rep-checklist/new-rep-checklist.component';
import { DueDiliegenceComponent } from '../onboarding-assessment/due-diliegence/due-diliegence.component';
import { MatIcon } from '@angular/material/icon';
import { IntroducerFormIndividualComponent } from '../new-introducer/introducer-form-individual/introducer-form-individual.component';
import { IntroducerFormCorporateComponent } from '../new-introducer/introducer-form-corporate/introducer-form-corporate.component';
import { NewIntroducerChecklist } from '../new-introducer-checklist/new-introducer-checklist';

@Component({
  selector: 'app-onboarding-assessment',
  imports: [
    CommonModule,
    MatTabsModule,
    PiasLayoutComponent,
    MatCardModule,
    MatTabGroup,
    NewRepApplicationPage,
    DueDiliegenceComponent,
    NewRepChecklistComponent,
    MatIcon,
    IntroducerFormIndividualComponent,
    IntroducerFormCorporateComponent,
    NewIntroducerChecklist,
    
  ],
  templateUrl: './onboarding-assessment.html',
  styleUrl: './onboarding-assessment.scss'
})
export class OnboardingAssessment implements OnInit {
  @ViewChild('onboardingTabs') tabGroup!: MatTabGroup;
  protected selectedTabId: string = "";
  selectedIndex: number = 0;
  totalTabs: number = 3;
  data = history.state;
  readonly = signal(false);
  designation!: string;
  constructor() { }
  ngOnInit(): void {
    this.selectedTabId = "new-repapplication";
    this.readonly.set(this.data.isReadOnly);
    this.designation = this.data.designation;
  }

  protected __onAgentOnboardingTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index;
    if (event.tab.id) {
      this.selectedTabId = event.tab.id.toString();
    }
    else {
      console.error(`Invalid tab ID for mat-tab[${event.index}]`);
    }
  }

  protected nextTab(): void {
    if (this.selectedIndex < this.totalTabs - 1) {
      this.selectedIndex++; // ✅ This automatically switches tab
    }
  }
}
